// T0 — Métadonnées de navigation des pages (titres lisibles + descriptions + icônes).
// Clé = nom de fichier de la page (sans .js) découvert par require.context dans App.js.
// Permet d'afficher des libellés conviviaux dans la sidebar et l'accueil au lieu des noms de fichiers.
// Les noms d'icônes correspondent aux exports de `lucide-react`.

export const PAGE_META = {
  ProcessDocumentation: {
    title: 'Processus',
    description: "Cartographie des processus d'audit : ingestion CBS, résolution des anomalies, gouvernance",
    icon: 'GitBranch',
    order: 1,
  },
  FunctionalSpecification: {
    title: 'Spécifications fonctionnelles',
    description: "Maquettes interactives des écrans ScanBank : paramétrage, suivi d'audit, rapports & supervision",
    icon: 'LayoutDashboard',
    order: 2,
  },
  InfrastructureDocumentation: {
    title: 'Architecture & Infrastructure',
    description: 'Zones réseau, composants (backend, frontend, PostgreSQL, dépôt SFTP, collecteur GENERO) et flux',
    icon: 'Network',
    order: 3,
  },
  API_Documentation: {
    title: 'API',
    description: 'Référence des endpoints REST ScanBank (collections Postman) avec console de test',
    icon: 'Webhook',
    order: 4,
  },
  'sdk-guide-page': {
    title: "Guide d'intégration CBS",
    description: 'Intégrer un Core Banking System : format XML, nomenclature, dépôt des fichiers',
    icon: 'Plug',
    order: 5,
  },
  InstallationGuide: {
    title: 'Installation',
    description: 'Déploiement du backend, du frontend, de PostgreSQL et du collecteur GENERO',
    icon: 'Download',
    order: 6,
  },
  ConfigurationGuide: {
    title: 'Configuration',
    description: 'Paramètres scanbank.*, système, sécurité (JWT/CORS) et intégration',
    icon: 'Settings2',
    order: 7,
  },
};

// Métadonnées d'une page (fallback : titre = nom de fichier).
export const pageMeta = (name) => PAGE_META[name] || { title: name, description: '', icon: 'FileText', order: 99 };
